import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogContent, DialogTitle, } from '@/components/ui/dialog';
import POSBookingDetail from '../src/pages/pos/booking-detail';
export function BookingDetailModal({ bookingId, open, onOpenChange, onClose }) {
    const handleClose = () => {
        onOpenChange(false);
        onClose?.();
    };
    return (_jsx(Dialog, { open: open, onOpenChange: (isOpen) => {
            onOpenChange(isOpen);
            if (!isOpen) {
                onClose?.();
            }
        }, children: _jsxs(DialogContent, { className: "bg-slate-900 border-slate-700 text-white !w-[95vw] !max-w-[95vw] !h-[95vh] !max-h-[95vh] p-0 overflow-hidden", showCloseButton: false, "aria-describedby": undefined, children: [_jsx(DialogTitle, { className: "sr-only", children: "Booking Detail" }), bookingId && (_jsx(POSBookingDetail, { bookingId: bookingId, onBack: handleClose }))] }) }));
}
export default BookingDetailModal;
